import React, {Component} from 'react';
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import {Collapse, Label} from 'reactstrap';
//import Select from 'react-select';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import ReactTooltip from 'react-tooltip';
import {Link} from 'react-router-dom';
import jwt_decode from "jwt-decode";
import {Nav, Navbar, NavItem} from "react-bootstrap";
import CommonNavbar, {navbar} from "./commonNavbar";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class MerchantPromotionMaster extends Component {
    constructor(props){
        super(props);
        this.state = {
            unmapped_files : [],
            unmappedData: {
                id: '',
                user_id: '',
                file_name: '',
                file_path: '',
                timestamp: '',
                version: '',
                cur_version: '',
                status:'',
                user_type: ''
            },
            unmappedModel: false,
            data:[],
            loading:true,
            _notificationSystem: null,
            versions:[],
            tableLists:[],
            newRelationModel: false,
            deleteKeys:[],
            user_id: null,
            map_status: null,
            stored_file_name: null,
            file_name: null,
            userGroup: null,
            id: null,
            campaign_response: [],
            party_master_id: null,
            party_master_name: null,
            emiMenus:[]
        };
    }

    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };

    componentDidMount() {
        //this._getVersions();
        this.getPartyID();
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
    }

    getPartyID(){
        if ($.fn.DataTable.isDataTable('#party_showTable')) {
            $('#party_showTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_id',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
            }
        }).then(response => {
            console.log(response.data);
            response.data.map((values, index) => {
                console.log(values.party_id);
                this.setState({
                    party_master_id: values.party_id
                })
            })
            this.setState({
                party_id_mapper: response.data
            });
            $('#party_showTable').DataTable();
            this.setState({
                loading: false,
                user_id: decoded._id
            });
            this.getPartyName();
        });
    }

    setDescription = (optionSelected) => {
        this.setState({ selectedDescription: optionSelected });
        console.log(this.state.selectedDescription)
    };
    updateSKU = (optionSelected) => {
        this.setState({ selectedSKU: optionSelected.value })
    };
    updatePrice = (optionSelected) => {
        this.setState({ selectedPrice: optionSelected.value })
    };

    toggleunmappedModel() {
        this.setState({
            unmappedModel: !this.state.unmappedModel
        })
    }

    campaignDropdown = () => {
        this.props.history.push('/admin/create-promotion')
    }

    _refreshCampaign() {
        if ($.fn.DataTable.isDataTable('#campaignTable')) {
            $('#campaignTable').DataTable().destroy();
        }
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        console.log(this.state.party_master_id);
        axios.get(config.get('API_URL') + '/brandemi/get_campaign_merchant',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                user_id: decoded._id,
                party_master_id: this.state.party_master_id,
                party_name: this.state.party_master_name
            }
            }).then(response => {
            console.log(response);
            this.setState({
                campaign_response: response.data
            });
            $('#campaignTable').DataTable();
            this.setState({
                loading: false
            })

        });
    }

    getPartyName() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.get(config.get('API_URL') + '/brandemi/get_party_name',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params: {
                party_master_id: this.state.party_master_id
            }
        }).then(response => {
            console.log(response.data);
            response.data.map((values, index) => {
                console.log(values.party_id);
                this.setState({
                    party_master_name: values.party_name
                })
            })
            this._refreshCampaign();
        });
    }

    mapData(id, map_status, stored_file_name, user_type, user_id, file_name){
        this.setState({
            id: id,
            map_status: map_status,
            stored_file_name: stored_file_name,
            userGroup: user_type,
            user_id: user_id,
            file_name: file_name
        });
        this.openSectionToMap(true);
    }

    goBack = () => {
        this.props.history.push('/admin/brand-emi')
    }

    openSectionToMap = (status) => {
        console.log(this.state.userGroup);
        this.setState({
            mapField: status
        })
    };

    updateMapVisiblity = (value) => {
        console.log(JSON.stringify(value));
        this.setState({
            mapField: value
        })
    };

    render() {

        let menus = this.state.emiMenus.map((menu, index) =>{
            return (
                <NavItem key={index} eventKey={index + "_" + 5} componentClass={Link} href={menu.layout+menu.path } to={menu.layout+menu.path}>
                    {menu.name}
                </NavItem>
            )
        });

        let campaign_data = this.state.campaign_response.map((value,index) => {
            let Activer = 'Inactive';
            let edit_activer = false;
            let timer = new Date(value.start_date).toJSON().slice(0, 10).replace('T', ' ');
            let timer1 = new Date(value.end_date).toJSON().slice(0, 10).replace('T', ' ');
            let timer2 = new Date(value.record_update_timestamp);
            timer2.setHours( timer2.getHours() + 5 );
            timer2.setMinutes( timer2.getMinutes() + 30 );
            // timer
            let timer3 = timer2.toJSON().slice(0, 19).replace('T', ' ');
            if (value.active != 0 || value.active != '0')
            {
                if (value.active == -1 || value.active == '-1'){
                    Activer = 'Rejected';
                    edit_activer=false;
                }
                else{
                    Activer = 'Active';
                    edit_activer=true;
                }

                return (
                    <tr key={index + 1}>
                        <td>{index + 1}</td>
                        <td>{value.campaign_name}</td>
                        <td>{value.campaign_desc}</td>
                        <td>{timer}</td>
                        <td>{timer1}</td>
                        {/* <td>{value.max_cashback}</td> */}
                        <td>{timer3}</td>

                        <td>
                            <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                            <Link className="viewButton" data-tip="View Promotion Summary"  to={"/admin/merchant-view-promotion/" + value.id}><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>
                        </td>
                        <td>{Activer}</td>
                    </tr>
                );
            }
            else{

                return (
                    <tr key={index + 1}>
                        <td>{index + 1}</td>
                        <td>{value.campaign_name}</td>
                        <td>{value.campaign_desc}</td>
                        <td>{timer}</td>
                        <td>{timer1}</td>
                        {/* <td>{value.max_cashback}</td> */}
                        <td>{timer3}</td>

                        <td>
                            <ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>
                            <Link className="viewButton" data-tip="View Promotion Summary"  to={"/admin/merchant-view-promotion/" + value.id}><span className="glyphicon glyphicon-eye-open" aria-hidden="true"></span></Link>

                        </td>
                        <td>{Activer}</td>
                    </tr>
                );
            }
        });

        return(<div className="content">
                <CommonNavbar/>
        <div className="card-query-builder top-pad-5 ">
                <NotificationSystem ref="notificationSystem" style={style} />
                <ReactTooltip />
                <div className="col-md-12">
                    <div className="card " ref={this.myRef}>
                        
                            <div className="header">
                                <h4 className="title pull-left">Promotions</h4>
                                {/*<button onClick={this.campaignDropdown} className="btn btn-primary btn-capitalize pull-right">Create New</button>*/}
                            </div>
                        <div className="content">
                            <div className='sweet-loading'>
                                <BeatLoader
                                    css={override}
                                    sizeUnit={"px"}
                                    size={20}
                                    color={'#123abc'}
                                    loading={this.state.loading}
                                />
                            </div>
                            {/* <div className="col-md-12">

                            </div> */}
                            <div className="row">
                            <div className="content table-full-width table-responsive">
                                <table className="table table-striped table-hover" id="campaignTable">
                                    <thead>
                                    <tr>
                                        <th>Sr_No.</th>
                                        <th>Promotion Name</th>
                                        <th>Promotion Description</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        {/* <th>Maximum Cashback</th> */}
                                        <th>Date Added</th>
                                        <th>Action</th>
                                        <th>Status</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        {campaign_data}
                                    </tbody>
                                </table>
                            </div>
                            </div>
                            <div className="footer">
                                <div className="stats"><i></i></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        );
    }
}


export default MerchantPromotionMaster;